import * as React from 'react';
import { AppStore } from '../stores/AppStore';
import { inject, observer } from 'mobx-react';
import { Helper } from '../../../Helper';
import { IAMessages } from '../../messages/Index';
import { IAppComponent } from '../../../interfaces/IAppComponent';
import { INode } from '../../../interfaces/INode';

export interface IMessagesContentAreaProps {
  store?: AppStore;
  pageIndex?: number;
  componentIndex?: number;
  component?: IAppComponent;
  selectedMessagesCategories?: INode[];
}

export interface IMessagesContentAreaState {
  hideComponent: boolean;
}

@inject('store')
@observer
export class MessagesContentArea extends React.Component<IMessagesContentAreaProps, IMessagesContentAreaState> {

  private id: string;

  constructor(props: IMessagesContentAreaProps) {
    super(props);
    this.state = {
      hideComponent: undefined
    }
    this.id = Helper.getRandomStringKey();
  }

  render(): JSX.Element {
    const component = this.props.component;
    return (
      this.state.hideComponent ? <></> :
        <div
          style={{
            padding: component.display === "RotatorView" && !component.showTitle && !component.showSearch && !component.showFilter && !this.props.store.editMode ? 0 : 25,
          }}
          key={`component_${this.id}`}
        >
          <IAMessages
            webpartId={`mobileApp-${this.props.pageIndex}-${this.props.componentIndex}`}
            appStore={this.props.store}
            noContentCallback={() => {
              this.setState({ hideComponent: true });
              console.log("noContentCallback");
            }}
            environment={this.props.store.environment}
            token={this.props.store.token}
            tenant={this.props.store.tenant}
            highlightColor={this.props.store.instance.settings.design.contentAreaHighlightColor}
            hasDarkBackground={Helper.getTextColorBasedOnBackgroundColorDarkness(this.props.store.instance.settings.design.contentAreaColor, true, false)}
            source="SharePoint"
            isAdminPage={false}
            isMobileApp
            preview={this.props.store.preview}
            panelIsOpen={(panelIsOpen: boolean) => {
              this.props.store.blockReload = panelIsOpen;
            }}
            webpartDisplayMode={this.props.store.editMode ? 2 : 1}
            rollupHighlightColor={component.higlightColor ?? (component.textColor ?? "#333333")}
            settings={{
              instance: component.instance,
              numMessages: component.numberOfCards ? component.numberOfCards : 10,
              showPaging: component.showPaging ?? true,
              addMessage: component.showAdd ? component.showAdd : false,
              display: component.display ? component.display : "Card view",
              showFilter: component.showFilter ? component.showFilter : false,
              shouldFilterByCategory: component.filterByCategory ? component.filterByCategory : false,
              isTargetingAvailable: component.useTargeting ? component.useTargeting : false,
              isFullPageView: false,
              backgroundColor: component.backgroundColor,
              textColor: component.textColor,
              borderColor: component.borderColor,
              borderRadius: component.borderRadius,
              showCategories: component.showCategories,
              selectedCategories: this.props.selectedMessagesCategories,
              showImage: component.showImage != undefined ? component.showImage : false,
              showAuthor: component.showContact != undefined ? component.showContact : false,
              showTeaser: component.showTeaser != undefined ? component.showTeaser : false,
              showTitle: component.showCardTitle != undefined ? component.showCardTitle : false,
              showStartDate: component.showStartDate != undefined ? component.showStartDate : false,
              showLikes: component.showLikes != undefined ? component.showLikes : false,
              showComments: component.showComments != undefined ? component.showComments : false,
              showUniqueViews: component.showViews != undefined ? component.showViews : false,
              showCommandBarItems: component.showFunctionButton != undefined ? component.showFunctionButton : false,
              showDropShadow: component.showDropShadow != undefined ? component.showDropShadow : false,
              showSearch: component.showSearch != undefined ? component.showSearch : false,
              header: component.showTitle != undefined ? component.showTitle : false || component.showSearch || component.showFilter,
              title: component.title,
              onlyShowIfThereIsContent: component.onlyShowIfThereIsContent,
              textIfNoContent: component.noContentText,
              showPinnedMessages: component.showPinnedMessages,
              onlyShowPinnedMessages: component.onlyShowPinnedMessages,
              autoRotate: component.autoRotate
            }}
          />
        </div>
    );
  }
}